<template>
    <all-topics type="hot" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'Hot',
}
</script>
